module.exports = __webpack_public_path__ + "static/media/ocorrencia-1.d1f5c602.svg";